import { memo } from 'react';
import { BigLoaderAnimationStyles } from '@dealstack/frontend/shared/components/loaders/BigLoaderAnimation/BigLoaderAnimation.styles.tsx';

const BigLoaderAnimation = () => (
	<BigLoaderAnimationStyles>
		<svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
			<rect
				className="box box-1"
				x="9.945"
				y="64"
				width="32"
				height="32"
				rx="8"
				fill="#959E9E"
			/>
			<rect
				className="box box-2"
				x="46.055"
				y="64"
				width="32"
				height="32"
				rx="8"
				fill="#959E9E"
			/>
			<rect
				className="box box-3"
				x="82.055"
				y="64"
				width="32"
				height="32"
				rx="8"
				fill="#959E9E"
			/>
			<rect
				className="box box-4"
				x="118.055"
				y="64"
				width="32"
				height="32"
				rx="8"
				fill="#959E9E"
			/>
		</svg>
	</BigLoaderAnimationStyles>
);
const _BigLoaderAnimationExport = memo(BigLoaderAnimation);

export { _BigLoaderAnimationExport as BigLoaderAnimation };
